module.exports = __webpack_public_path__ + "media/application/images/demsoc/tiles/monochrome_3-e45084a94fadaa6530e31f55971b3569.jpg";